<ng-template #actions>
  <!-- The rail's button row as every app draws it: the primary New with 8px corners taking the room, then the
       icon-only Gray/200 Add (stitch-app-shell skin, issue 4). The search box below is the shell's own.
       Aligned with slides-rail-controls.component.html:2-28 after #2716 (6d44ebb35). -->
  <div class="boards-rail-actions flex shrink-0 items-center gap-4">
    <app-button2
      appearance="primary"
      size="s"
      [height]="32"
      rounding="lg"
      class="min-w-0 flex-1"
      stchPopover
      stchPopoverTrigger="click"
      stchPopoverPlacement="bottomLeft"
      [stchPopoverContent]="newBoardPopover"
      [stchPopoverShowUntil]="newBoardPopoverClose"
    >
      <!-- The app's own glyph, as every other app's New button (stitch-app-shell skin). -->
      <app-icon name="plus" size="m" />
      New board
      <!-- The down arrow says New board opens a menu, as Sheets' New workbook and Slides' New deck. -->
      <app-icon name="chevron-down" [size]="14" />
    </app-button2>

    <!-- The same global Add panel as every other app (item types, More, their own new-item forms). -->
    <app-nav-add-menu [app]="app" appearance="rail" />
  </div>
</ng-template>

<!-- The nav menu, each choice with its icon, as Sheets' New workbook menu and Slides' New deck menu
     (slides-rail-controls.component.html:31-38). A board's glyph is the one the stitch icon map gives it. -->
<ng-template #newBoardPopover>
  <app-context-menu-window>
    <app-context-menu-item appearance="nav" title="Blank board" (execute)="createBlank()" />
    <app-context-menu-item appearance="nav" title="From a template" icon="sapphire-template" (execute)="createFromTemplate()" />
    <app-context-menu-item appearance="nav" title="Import board" icon="upload" (execute)="importBoard()" />
  </app-context-menu-window>
</ng-template>
